module.exports = "/_next/static/images/9fe3339167fd0afa7a27107d1eba038f-slide2mobile.jpg";